var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.$route.meta.hideNavbar)?_c('navbar'):_vm._e(),(!_vm.$route.meta.hideNavbar && _vm.$context.office)?_c('side-menu'):_vm._e(),_c('v-main',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('toasts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }